<template>
  <div class="things-like-container">
    <el-row :gutter="20" type="flex">
      <el-col :span="8">
        <common-card card-title="想去的国家">
          <div
            v-if="userDetailCountries && userDetailCountries.length > 0"
            class="tag-container"
            :style="{ minHeight }"
          >
            <div v-for="item in userDetailCountries" :key="item" class="tag">
              <el-tag size="small">{{ item }}</el-tag>
            </div>
          </div>
        </common-card>
      </el-col>
      <el-col :span="8">
        <common-card card-title="想去的城市">
          <div
            v-if="userDetailCities && userDetailCities.length > 0"
            class="tag-container"
            :style="{ minHeight }"
          >
            <div v-for="city in userDetailCities" :key="city" class="tag">
              <el-tag size="small">{{ city }}</el-tag>
            </div>
          </div>
        </common-card>
      </el-col>
      <el-col :span="8">
        <common-card card-title="交易方式">
          <div
            v-if="userDetailPayType && userDetailPayType.length > 0"
            class="tag-container"
            :style="{ minHeight }"
          >
            <div v-for="trade in userDetailPayType" :key="trade" class="tag">
              <el-tag size="small">{{ payTypeEnum[trade] }}</el-tag>
            </div>
          </div>
        </common-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CommonCard from "@/components/CommonCard";
import { mapGetters } from "vuex";
import { payTypeEnum } from "../const";
export default {
  name: "DetailThingsLike",
  components: {
    CommonCard
  },
  data() {
    return {
      payTypeEnum,
      minHeight: "150px"
    };
  },
  computed: {
    ...mapGetters([
      "userDetailCountries",
      "userDetailCities",
      "userDetailPayType"
    ])
  }
}
</script>

<style lang="scss" scoped>
.things-like-container {
  margin-top: 1.2rem;
  .tag-container {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .tag {
      margin-top: 16px;
      margin-left: 18px;
      height: 20px;
    }
  }
}
</style>
